<!---------------------------->
<!-- STEP: Contacts:-->
<!---------------------------->

<form [formGroup]="contactFormGroup">
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Designation</mat-label>
        <mat-select [formControl]="designationFormControl">
          <mat-option *ngFor="let designation of designations" [value]="designation">
            {{designation.name}}
          </mat-option>
        </mat-select>
      
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Designation')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input [formControl]="emailFormControl" matInput pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
               type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Email')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Title</mat-label>
        <mat-select [formControl]="titleFormControl">
          <mat-option *ngFor="let title of titles" [value]="title">
            {{title.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Title')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Mobile</mat-label>
        <input (input)="onInputChangedCheckMobileNumber()" [formControl]="mobileFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Mobile')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input [formControl]="firstNameFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('First Name')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Landline</mat-label>
        <input (input)="onInputChangedCheckLandlineNumber()" [formControl]="landlineFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Landline')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Middle Name</mat-label>
        <input [formControl]="middleNameFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Middle Name')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input [formControl]="lastNameFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Last Name')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <div class="m-r-35 m-t-5">
        <app-element-checkbox
          [formControl]="doNotOverwriteContact"
          label="Do Not Override">
        </app-element-checkbox>
      </div>
      <button (click)="addContact()" color="primary" mat-raised-button>Add Contact</button>
    </mat-grid-tile>
  </mat-grid-list>
  <div class="align-center">
    <div *ngIf="!contactsRequiredFieldsSelected" class="font-red">{{contactMessage}}
    </div>
  </div>
  <mat-divider *ngIf="selectedContacts.length > 0" style="margin-bottom: 16px;margin-top: 16px;"></mat-divider>
  <mat-error *ngIf="contactFormGroup.errors && contactFormGroup.errors.minimumContacts"
             class="left-content claim-column-label">
    {{contactErrorMessages.minContactError}}
  </mat-error>
  
  <div *ngIf="selectedContacts && selectedContacts.length > 0" class="left-content">
    <label class="column-label claim-column-label">Selected Contacts</label>
  </div>
  <div *ngFor="let contactElement of selectedContacts" class="left-content reporting-list">
    <mat-icon (click)="removeContact(contactElement)" class="table-icon" matTooltip="REMOVE Contact">delete</mat-icon>
    &nbsp;
    <mat-icon (click)="editContact(contactElement)" class="table-icon" matTooltip="EDIT CONTACT">edit</mat-icon> &nbsp;
    <p>
      {{getContactDisplayString(contactElement)}}
    </p>
    
    <div class="m-l-15">
      <app-element-checkbox [defaultValue]="(contactElement.contact || contactElement.contactDTO)?.doNotOverwrite"
                            [disabled]="true"
                            label="Do Not Override"></app-element-checkbox>
    </div>
  </div>
  <div class="button-container">
    <button #contactBackButton color="primary" mat-raised-button matStepperPrevious>Back</button>
    <button (click)="resetContactFormGroup()" color="warn" mat-raised-button>Clear</button>
    <button color="primary" mat-raised-button matStepperNext>Next</button>
  </div>
</form>